import React, { Fragment, useEffect, useState } from "react";
import UserPanel from "./user-panel";
import { Link } from "react-router-dom";
import { MENUITEMS } from "../../../constants/menu";
import { Phone } from "react-feather";
// image import
// import logo from "../../../assets/images/dashboard/logo.png";
import logo from "../../../assets/images/dashboard/Logo Amr Khamis El Yousr.png";
import { Button } from "reactstrap";

const Sidebar = ({ sidebar, setSidebar }) => {
	const cloneMenu = (menu) => {
		return menu.map((item) => ({
			...item,
			children: item.children ? cloneMenu(item.children) : item.children,
		}));
	};

	const [mainmenu, setMainMenu] = useState(cloneMenu(MENUITEMS));
	const [isChange, setIsChange] = useState(false);

	const openCloseSidebar = () => {
		setSidebar(false);
		document.querySelector(".page-main-header").classList.add("open");
		document.querySelector(".page-sidebar").classList.add("open");
		document.querySelector(".footer").classList.add("open");
	};

	useEffect(() => {
		const currentUrl = window.location.pathname;
		const updatedMenu = mainmenu.map((item) => {
			const newItem = { ...item };
			let isParentActive = false;

			if (newItem.path === currentUrl) {
				newItem.active = true;
				isParentActive = true;
			}

			if (newItem.children) {
				newItem.children = newItem.children.map((child) => {
					const newChild = { ...child };
					if (newChild.path === currentUrl) {
						newChild.active = true;
						newItem.active = true;
						isParentActive = true;
					}
					if (newChild.children) {
						newChild.children = newChild.children.map((subChild) => {
							const newSubChild = { ...subChild };
							if (newSubChild.path === currentUrl) {
								newSubChild.active = true;
								newChild.active = true;
								newItem.active = true;
								isParentActive = true;
							}
							return newSubChild;
						});
					}
					return newChild;
				});
			}
			return newItem;
		});
		setMainMenu(updatedMenu);
	}, []);

	const setNavActive = (item) => {
		const updatedMenu = mainmenu.map((menuItem) => {
			// Check if the current top-level menuItem or any of its children is the toggled item
			const isToggledThisItem = menuItem === item;
			const isToggledAChild = menuItem.children?.some(
				(child) =>
					child === item || child.children?.some((subChild) => subChild === item),
			);

			const newItem = { ...menuItem };

			if (isToggledThisItem) {
				newItem.active = !newItem.active;
			} else if (!isToggledAChild) {
				// If this isn't the toggled item and it's not a parent of the toggled item, close it
				newItem.active = false;
			} else {
				// It's a parent of the toggled item, keep it active
				newItem.active = true;
			}

			if (newItem.children) {
				newItem.children = newItem.children.map((submenuItem) => {
					const isToggledThisSub = submenuItem === item;
					const isToggledASubChild = submenuItem.children?.some(
						(subChild) => subChild === item,
					);

					const newSubmenuItem = { ...submenuItem };

					if (isToggledThisSub) {
						newSubmenuItem.active = !newSubmenuItem.active;
					} else if (!isToggledASubChild) {
						newSubmenuItem.active = false;
					} else {
						newSubmenuItem.active = true;
					}

					if (newSubmenuItem.children) {
						newSubmenuItem.children = newSubmenuItem.children.map((childItem) => {
							const isToggledThisChild = childItem === item;
							const newChildItem = { ...childItem };
							if (isToggledThisChild) {
								newChildItem.active = !newChildItem.active;
							}
							return newChildItem;
						});
					}
					return newSubmenuItem;
				});
			}
			return newItem;
		});

		setMainMenu(updatedMenu);
		setIsChange(!isChange);
	};

	const menuItemsList = mainmenu.map((menuItem, i) => (
		<li className={`${menuItem.active ? "active" : ""}`} key={i}>
			{menuItem.sidebartitle ? (
				<div className="sidebar-title">{menuItem.sidebartitle}</div>
			) : (
				""
			)}
			{menuItem.type === "sub" ? (
				<a
					className="sidebar-header "
					href="#javaScript"
					onClick={(event) => {
						event.preventDefault();
						return setNavActive(menuItem);
					}}>
					{menuItem.icon && <menuItem.icon />}
					<span>{menuItem.title}</span>
					<i className="fa fa-angle-right pull-right"></i>
				</a>
			) : (
				""
			)}
			{menuItem.type === "link" ? (
				<Link
					to={`${process.env.PUBLIC_URL}${menuItem.path}`}
					className={`sidebar-header ${menuItem.active ? "active" : ""}`}
					onClick={() => {
						setNavActive(menuItem);
					}}>
					{menuItem.icon && <menuItem.icon />}
					<span>{menuItem.title}</span>
					{menuItem.children ? <i className="fa fa-angle-right pull-right"></i> : ""}
				</Link>
			) : (
				""
			)}
			{menuItem.children ? (
				<ul
					className={`sidebar-submenu ${menuItem.active ? "menu-open" : ""}`}
					style={
						menuItem.active ? { opacity: 1, transition: "opacity 500ms ease-in" } : {}
					}>
					{menuItem.children.map((childrenItem, index) => (
						<li
							key={index}
							className={
								childrenItem.children ? (childrenItem.active ? "active" : "") : ""
							}>
							{childrenItem.type === "sub" ? (
								<a
									href="#javaScript"
									onClick={(event) => {
										event.preventDefault();

										return setNavActive(childrenItem);
									}}>
									<i className="fa fa-circle"></i>
									{childrenItem.title} <i className="fa fa-angle-right pull-right"></i>
								</a>
							) : (
								""
							)}

							{childrenItem.type === "link" ? (
								<Link
									to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
									className={childrenItem.active ? "active" : ""}
									onClick={() => {
										//! implement
										openCloseSidebar();
										setNavActive(childrenItem);
									}}>
									<i className="fa fa-circle"></i>
									{childrenItem.title}{" "}
								</Link>
							) : (
								""
							)}
							{childrenItem.children ? (
								<ul
									className={`sidebar-submenu ${
										childrenItem.active ? "menu-open" : "active"
									}`}>
									{childrenItem.children.map((childrenSubItem, key) => (
										<li className={childrenSubItem.active ? "active" : ""} key={key}>
											{childrenSubItem.type === "link" ? (
												<Link
													to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
													className={childrenSubItem.active ? "active" : ""}
													onClick={() => setNavActive(childrenSubItem)}>
													<i className="fa fa-circle"></i>
													{childrenSubItem.title}
												</Link>
											) : (
												""
											)}
										</li>
									))}
								</ul>
							) : (
								""
							)}
						</li>
					))}
				</ul>
			) : (
				""
			)}
		</li>
	));

	return (
		<Fragment>
			<div className="page-sidebar open">
				<div className="main-header-left d-none d-lg-block">
					<div className="logo-wrapper">
						<Link to={`${process.env.PUBLIC_URL}/dashboard`}>
							<img className="blur-up lazyloaded" src={logo} alt="" width={"165px"} />
						</Link>
					</div>
				</div>
				<div className="sidebar custom-scrollbar">
					<UserPanel />
					{/* <div className="sidebar-action-btn px-4 mb-3">
						<Link
							to={`${process.env.PUBLIC_URL}/products/add-main-product`}
							className="btn btn-primary w-100 d-flex align-items-center justify-content-center py-2"
							style={{
								borderRadius: "12px",
								backgroundColor: "#ff8084",
								border: "none",
								boxShadow: "0 4px 15px rgba(255, 128, 132, 0.2)",
								fontWeight: "600",
								fontSize: "14px",
							}}>
							<i className="fa fa-plus me-2" style={{ fontSize: "12px" }}></i>
							إضافة منتج جديد
						</Link>
					</div> */}
					<ul className="sidebar-menu">{menuItemsList}</ul>
				</div>
			</div>
		</Fragment>
	);
};

export default Sidebar;
